import { render, staticRenderFns } from "./Author.vue?vue&type=template&id=bc9b1628&scoped=true&"
var script = {}
import style0 from "./Author.vue?vue&type=style&index=0&id=bc9b1628&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9b1628",
  null
  
)

export default component.exports